import React from "react";
import { useEffect } from "react";
import checkMark from "../../images/Svg/CheckMark.svg";
import MailOpen from "../../images/Svg/MailOpen.svg";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import handShake from "../../images/Svg/HandShake.svg";
import leaveDoor from "../../images/Svg/LeaveDoor.svg";
import close from "../../images/Svg/close.svg";
import { handleRealTimeLoading } from "../../reducers/auth/action";
import Spinner from "../spinner/Spinner.component";
import Iframe from "../iframe/Iframe.component";
import { useState } from "react";
import { getScreenshotApi } from "../../Network/network";
import LoadingShapeIcon from "../../images/Svg/loadingShape2.gif";
import { TwitterShareButton } from "react-share";
import GetDesoProfile from "../../Hooks/GetDesoProfile";
import { gaEvents, pushGaEvent } from "../../utils/ga_events";

const GifLoadingSpinner = () => {
  return (
    <div className="pb-[40px] flex items-center md:inline h-[652px] lg:h-[600px]">
      <div>
        <div>
          {/* using gif file */}
          <img className="w-full" src={LoadingShapeIcon} alt="" />
        </div>
        <h1 className="Secondheading font-bold text-center">
          Your tweets are being shifted!
        </h1>
        <p className="text-[16px] text-[#00000] text-center mt-[16px] px-[16px] lg:px-0">
          It will take a few minutes to reflect on your DeSo profile.
        </p>
      </div>
    </div>
  );
};

const RealTimeSyncModal = ({
  deleteShow,
  setDeleteShow,
  UnSubscribe,
  real_time_show,
}) => {
  const { id } = useParams();
  const { realTimeLoading } = useSelector((state) => state.auth);
  const dispatch = useDispatch();

  const handleGoBack = () => {
    pushGaEvent(`${id}_MODAL_GO_BACK_BUTTON_CLICKED`);
    window.location.href = "/";
  };

  const handleClose = () => {
    pushGaEvent(
      gaEvents[`${id.toUpperCase()}_UNSUBSCRIBE_CANCEL_BUTTON_CLICKED`]
    );
    setDeleteShow(false);
  };
  const handleCloseIcon = () => window.location.reload(true);

  const status = sessionStorage.getItem("status");
  const rtd = JSON.parse(sessionStorage.getItem("real_time_data"));

  const handleBack = () => {
    pushGaEvent(`${id}_SYNC_PAST_MODAL_GO_BACK_BUTTON_CLICKED`);
    window.location.href = "sync_your_content";
  };
  const [imageLoading, setImageLoading] = useState(true);
  const [screenshot_url, setScreenshot_url] = useState("");
  const pub_key = JSON.parse(localStorage.getItem("credential")).publicKeyAdded;

  useEffect(() => {
    if (!deleteShow) {
      dispatch(handleRealTimeLoading(true));
    }
  }, []);

  useEffect(() => {
    if (!deleteShow && status === "success") {
      dispatch(handleRealTimeLoading(true));
      setTimeout(() => {
        dispatch(handleRealTimeLoading(false));
        sessionStorage.removeItem("status");
      }, 5000);
    }
  }, [status, deleteShow]);

  useEffect(() => {
    if (pub_key && !real_time_show) {
      fetchData();
    }
  }, [pub_key, real_time_show]);

  const fetchData = async () => {
    const response = await getScreenshotApi({ public_key: pub_key });
    if (response.screenshot_url) {
      setScreenshot_url(response.screenshot_url);
    }
    setImageLoading(false);
  };
  const { username } = GetDesoProfile();

  const [inviteFriend, setInviteFriend] = useState(false);
  const h = 1000;
  const w = 800;
  const y = window.outerHeight / 2 + window.screenY - h / 2;
  const x = window.outerWidth / 2 + window.screenX - w / 2;

  const handleInviteFriend = () => {
    pushGaEvent(gaEvents[`${id.toUpperCase()}_INVITE_BUTTON_CLICKED`]);
    setInviteFriend(true);
  };

  const openTwitter = () => {
    pushGaEvent(gaEvents.SHARE_ON_TWITTER_BUTTON_CLICKED);
    window.open(
      `https://twitter.com/intent/tweet?text=Check out my profile on the diamond app. Looks interesting? Why not use web3setu.com to signup on Decentralised Social Media today!\n\n https://diamondapp.com/u/${username}`,
      null,
      `toolbar=no, width=${w}, height=${h}, top=${y}, left=${x}`
    );
    setInviteFriend(false);
    window.location.reload(true);
  };
  return (
    <>
      <Iframe />
      <div className="another_style">
        {real_time_show ? (
          inviteFriend ? (
            <>
              <div
                id="defaultModal"
                tabIndex="-1"
                aria-hidden="true"
                className={` ${
                  realTimeLoading ? "py-10" : "p-10"
                } invite_section_1 mx-auto text-center w-[560px]`}
              >
                <div className="w-[100%] max-w-[400px] mx-auto text-center">
                  {!deleteShow && (
                    <div className="flex justify-end">
                      <img
                        onClick={handleCloseIcon}
                        className="cursor-pointer"
                        src={close}
                        alt=""
                      />
                    </div>
                  )}
                  <img className="mx-auto" src={MailOpen} alt="" />
                  <h1 className="text-[30px] md:text-[36px] font-bold text-[#000000] mt-[24px]">
                    Invite your friends to DeSo
                  </h1>
                  <p className="text-[16px] text-[#161616] mt-[16px] text-center">
                    Tweet about DeSo and invite your friends to visit your
                    profile!
                  </p>

                  <button
                    onClick={openTwitter}
                    className="hero_button w-[203px] mx-auto mt-[86px] h-[48px] rounded-[8px] justify-center hover:bg-[#283AF2]"
                  >
                    Share on Twitter
                  </button>
                </div>
              </div>
            </>
          ) : (
            <>
              <div
                id="defaultModal"
                tabIndex="-1"
                aria-hidden="true"
                className={` ${
                  realTimeLoading ? "py-10" : "p-10"
                } invite_section_1 mx-auto text-center w-[560px]`}
              >
                {realTimeLoading ? (
                  <Spinner />
                ) : (
                  <div className="w-[100%] max-w-[400px] mx-auto text-center">
                    {!deleteShow && (
                      <div className="flex justify-end">
                        <img
                          onClick={handleCloseIcon}
                          className="cursor-pointer"
                          src={close}
                          alt=""
                        />
                      </div>
                    )}
                    <img
                      className="mx-auto"
                      src={deleteShow ? leaveDoor : handShake}
                      alt=""
                    />
                    <h1 className="text-[30px] md:text-[36px] font-bold text-[#000000] mt-[13px]">
                      {deleteShow ? (
                        <>We hope to see you again!</>
                      ) : (
                        <>
                          You are now <br />{" "}
                          <span className="text-blue">subscribed!</span>
                        </>
                      )}
                    </h1>
                    <p className="mt-[20px] text-[#000000] text-center">
                      {deleteShow ? (
                        <>
                          Your content will no longer be automatically synced to
                          DeSo.
                        </>
                      ) : (
                        <>You can change the settings any time you want</>
                      )}
                    </p>
                    {deleteShow && (
                      <p className="text-[16px] mt-[12px] text-[#000000]">
                        Confirm to unsubscribe.
                      </p>
                    )}

                    {!deleteShow && (
                      <>
                        <p className="text-blue pt-[24px]">
                          {rtd?.subscription_type == "all_tweets"
                            ? `All your ${id == "twitter" ? "tweets" : "blogs"}`
                            : rtd?.subscription_type == "include_hashtags"
                            ? `All ${
                                id == "twitter" ? "tweets" : "blogs"
                              } containing the hashtags`
                            : `All ${
                                id == "twitter" ? "tweets" : "blogs"
                              } containing the hashtags will not be shifted to DeSo.`}
                          {rtd?.subscription_type == "all_tweets" ||
                          rtd?.subscription_type == "include_hashtags"
                            ? rtd?.include_retweets
                              ? " including retweets"
                              : rtd?.include_quote_tweets
                              ? "including"
                              : " "
                            : rtd?.include_retweets && "Retweets"}{" "}
                          {rtd?.include_retweets &&
                            rtd?.include_quote_tweets &&
                            "and"}{" "}
                          {rtd?.include_quote_tweets && "quote tweets"}{" "}
                          {rtd?.subscription_type !== "exclude_hashtags"
                            ? "will be shifted to DeSo"
                            : rtd?.include_retweets || rtd?.include_quote_tweets
                            ? "will be shifted to DeSo"
                            : " "}
                        </p>
                      </>
                    )}
                    <div className="text-center flex items-center justify-center">
                      {deleteShow && (
                        <div className="button_hover">
                          <button
                            onClick={UnSubscribe}
                            className="mx-2 hero_button  mt-6 bg-blue rounded-[8px] w-[158px] justify-center h-[48px] hover:bg-[#283AF2]"
                          >
                            {" "}
                            Confirm
                          </button>
                        </div>
                      )}

                      <button
                        onClick={deleteShow ? handleClose : handleGoBack}
                        className={`${
                          deleteShow
                            ? "mt-6 text-black  cursor-pointor w-[100px] hover:bg-[#EEEFFF] h-[48px]"
                            : "hero_button w-[135px] mt-6 h-[48px] bg-[#5463FF] hover:bg-[#283AF2]"
                        } mx-2 rounded-[8px]  justify-center `}
                      >
                        {deleteShow ? "Cancel" : " Go Home"}
                      </button>
                      {!deleteShow && (
                        <button
                          onClick={handleInviteFriend}
                          className="mt-6 border border-[#9F63FF] rounded-[8px] text-[white] bg-[#9F63FF] w-[135px] h-[48px] ml-[24px]"
                        >
                          Invite Friends
                        </button>
                      )}
                    </div>
                  </div>
                )}
              </div>
            </>
          )
        ) : (
          <>
            {" "}
            <div className="invite_section_1 w-[900px] h-[652px] md:h-[600px] ">
              {realTimeLoading || imageLoading ? (
                <GifLoadingSpinner />
              ) : (
                <div className="px-[24px] lg:px-[48px] pt-[40px] lg:pb-[40px]">
                  <div className="flex justify-end">
                    <img
                      onClick={() => window.location.reload(true)}
                      className="cursor-pointer hidden md:inline-block"
                      src={close}
                      alt=""
                    />
                  </div>
                  <div className="grid sm:grid-cols-1 md:grid-cols-2 gap-6 items-center">
                    <div>
                      <div className="flex justify-between">
                        <img
                          className="w-[64px] h-[64px] lg:w-[87px] lg:h-[87px]"
                          src={handShake}
                          alt=""
                        />
                        <img
                          onClick={() => window.location.reload(true)}
                          className="cursor-pointer md:hidden"
                          src={close}
                          alt=""
                        />
                      </div>
                      <h1 className="text-[#161616] text-[32px] lg:text-[36px] title font-bold mt-[12px] mb-[8px] lg:mt-[24px] lg:mb-[16px] ">
                        Your tweets have now been shifted!
                      </h1>
                      <p className="text-[#161616] text-[14px] lg:text-[16px] ">
                        It will take a few minutes to reflect on your DeSo
                        profile. Check your tweets on DeSocialWorld.
                      </p>
                      <div className="text-center lg:text-justify mb-[16px]">
                        <button
                          onClick={handleBack}
                          className="bg-[#5463FF] py-[12px] px-[32px] mt-[16px] lg:mt-[40px] text-white rounded-[4px] mx-auto md:mx-0 flex items-center w-[135px] h-[40px] lg:h-[48px] justify-center"
                        >
                          Go Back
                        </button>
                      </div>
                    </div>
                    <div>
                      <div className="crop md:h-[521px] ">
                        {imageLoading ? (
                          <Spinner />
                        ) : (
                          <img
                            className="w-[100%]"
                            src={screenshot_url}
                            alt=""
                          />
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </>
        )}
      </div>
    </>
  );
};

export default RealTimeSyncModal;
